// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  apiUrl: 'https://dev.senemrfp.com/senem-api/api/',
  baseUrl: 'https://dev.senemrfp.com/senem-api/',
  appUrl: 'https://dev.senemrfp.com/',
  // apiUrl: 'https://localhost:7069/api/',
  // baseUrl: 'https://localhost:7069/',
  // appUrl: 'https://localhost:7069/',
  stripePublicKey: 'pk_test_51OFEytEHELDq4pAqfWBVV6dfTwHDg2Hin3gc01PY5lIhdCn3E8GH2gFY7cqL5BNx0QHqGDnJnpuen9q1oJvkwtMv00mWod4uQQ',
  // White-label social media referral hosts (used for local testing).
  // Add 'localhost' here temporarily if you want to test the domain gating locally.
  // socialMediaHosts: [] as string[],
  // // Base URL used when generating the social media referral link shown to firms.
  // // Empty -> falls back to window.location.origin for local dev.
  // socialMediaBaseUrl: '',

      // Hosts for the white-label social media referral domain (from Network Solutions).
    // When the app is served on any of these hosts, ONLY the social media
    // registration flow is reachable; every other route is redirected back to the
    // agency signup page. Add the exact dev subdomain here (lowercase, no protocol/port).
    socialMediaHosts: ['dev.insrfp.com'],
    // Base URL used when generating the social media referral link shown to firms.
    // The firm copies THIS white-label link (not the senemrfp.com host).
    socialMediaBaseUrl: 'https://dev.insrfp.com',
};
//7069
//7069

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
